





















































import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator';
import dataProxy from '../../../services/data-proxy.service';
import {StatusVozila} from "@/services/BackendProxies";
import {mixins} from "vue-class-component";
import {ComponentBaseMixin} from "@/mixins/component-base.mixin";

@Component({})
export default class StatusiVozila extends mixins(ComponentBaseMixin) {
    columns;
    options = {
        pagination: true,
        search: true,
        onClickRow: status => this.edit(status)
    };
    dataSource = [];
    statusVozila = new StatusVozila();

    async created() {
        this.columns = [
            {field: 'naziv', title: this.$i18n.t('naziv')},
            {
                field: 'podrazumevan',
                title: this.$i18n.t('podrazumevan'),
                width: 150,
                formatter: (value) => value ? this.$i18n.t('da') : this.$i18n.t('ne')
            },
            {
                field: 'aktivan',
                title: this.$i18n.t('aktivan'),
                width: 150,
                formatter: (value) => value ? this.$i18n.t('da') : this.$i18n.t('ne')
            },
            {
                field: 'inventarskiVozniPark',
                title: this.$i18n.t('inventarskiVozniPark'),
                width: 150,
                formatter: (value) => value ? this.$i18n.t('da') : this.$i18n.t('ne')
            }
        ];

        this.dataSource = await this.loadData<StatusVozila[]>(() => dataProxy.vratiStatuseVozila())();
    }

    edit(row: StatusVozila) {
        this.statusVozila = row;
    }

    kreirajNov() {
        this.statusVozila = new StatusVozila();
        (<HTMLElement>this.$refs.naziv).focus();
    }

    async obrisi() {
        const da = await this.confirmationNeeded('da li zelite da obrisete status vozila');
        if (da) {
            this.dataSource = await this.deleteData(() => dataProxy.obrisiStatusVozila(this.statusVozila.id))();
            this.kreirajNov();
        }
    }

    async sacuvaj() {
        const isValid = await (<any>this.$refs.form).validate();
        if (isValid) {
            this.statusVozila.id = await this.saveData(() => dataProxy.sacuvajStatusVozila(this.statusVozila))();
            this.dataSource = await this.loadData(() => dataProxy.vratiStatuseVozila())();
        }
    }
}
